import { Service } from '@phishtool/service';
import getExchangeRatesController from '~server/controllers/service/exchange-rates';
export class ExchangeRateService extends Service {
    constructor() {
        super(...arguments);
        this.useGetExchangeRates = this.addCollectionNonResourceQuery({
            routeId: 'rates',
            controller: getExchangeRatesController,
            middleware: [],
            opts: {
                staleTime: Infinity,
            },
        });
    }
}
